var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 18.2857H20V29.7143C20 30.9714 18.875 32 17.5 32C16.125 32 15 30.9714 15 29.7143V18.2857H2.5C1.125 18.2857 0 17.2571 0 16C0 14.7429 1.125 13.7143 2.5 13.7143H15V2.28571C15 1.02857 16.125 0 17.5 0C18.875 0 20 1.02857 20 2.28571V13.7143H32.5C33.875 13.7143 35 14.7429 35 16C35 17.2571 33.875 18.2857 32.5 18.2857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.cfa31fc9be6a14ddd3644a5aae6a496a.svg";
export { ForwardRef as ReactComponent };